import React, { useEffect } from 'react'
import { Portal } from 'react-portal'
import { connect } from 'react-redux'

import S from './styled'
import LoginForm from './loginForm'


function hasClass(ele,cls) {
  return !!ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'))
}

function addClass(ele,cls) {
  if (!hasClass(ele,cls)) ele.className += ' '+cls
}

function removeClass(ele,cls) {
  if (hasClass(ele,cls)) {
    let reg = new RegExp('(\\s|^)'+cls+'(\\s|$)')
    ele.className=ele.className.replace(reg,' ')
  }
}

const LoginOverlay = ({ sessionExpired }) => {

  useEffect(() => {
    if (sessionExpired) {
      addClass(document.getElementById('root'), 'blured')
    }
    return () => {
      removeClass(document.getElementById('root'), 'blured')
    }
  }, [sessionExpired])

  return sessionExpired && (
    <Portal>
      <S.LoginOverlay />
      <S.LoginOverlayContainer>
        <LoginForm doNotRedirect/>
      </S.LoginOverlayContainer>
    </Portal>
  )
}

const mapStateToProps = (state, { entityName }) => ({
  sessionExpired: state.session.expired,
})

export default connect(mapStateToProps)(LoginOverlay)
